import { getIsEndDatePassed } from "@/lib/contentUtils";
import { ContentGroupMember } from "@/lib/types";
import { getContentDetails } from "@/sideEffects/api";
import { selectActiveFirm } from "@/store/appSelectors";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

interface Props {
  contentGroupMember: ContentGroupMember;
}

export const ContentGroupMemberName = ({ contentGroupMember }: Props) => {
  const activeFirm = useSelector(selectActiveFirm);
  const { data } = useQuery({
    queryKey: ["contentGroupMember", contentGroupMember.contentGuid],
    queryFn: () => getContentDetails(String(activeFirm?.firmGuid), contentGroupMember.contentGuid),
  });

  const contentDetails = data?.data;

  if (!contentDetails) return contentGroupMember.name;

  const isExpired = contentDetails.endDate ? getIsEndDatePassed(contentDetails.endDate) : false;

  return (
    <div>
      {contentGroupMember.name} {isExpired ? <span className="text-red-500 font-bold">(Expired)</span> : null}
    </div>
  );
};
